import { render, staticRenderFns } from "./CheckoutTotalBox.vue?vue&type=template&id=f0a3ff02"
import script from "./CheckoutTotalBox.vue?vue&type=script&lang=js"
export * from "./CheckoutTotalBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports